// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"LR","facetClass":"MR"};